class Loader {
    /**
     * Constructor
     */
    constructor(config) {
        /**
         * @type {HTMLElement}
         */
        this.loader = document.createElement('div');
        /**
         * @type {null|HTMLElement}
         */
        this.overlay = null;
        /**
         * @type {{color,container,overlay}}
         */
        this.config = {
            color: (config && config.color) ? config.color : false,
            backgroundOverlay: (config && config.backgroundOverlay) ? config.backgroundOverlay : false,
            container: ((config && config.container) ? (typeof config.container === 'object' ? config.container : document.querySelector(config.container)) : document.body),
            overlay: (config && config.overlay) ? config.overlay : false,
            center: (!(config && config.center === false))
        };
        /**
         * @type {null|HTMLElement}
         */
        this.overlay = null;
        /**
         * Init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        this.loader.className = 'loader';
        this.loader.innerHTML = '<div></div><div></div><div></div><div></div>';
    }

    /**
     * Show loader
     */
    show() {

        if (this.config.color) {
            const DIVS = this.loader.querySelectorAll('div');

            for (let i = 0; i < DIVS.length; i++) {
                DIVS[i].style.borderColor = this.config.color + ' transparent transparent';
            }
        }

        if (this.config.container !== document.body) {
            this.loader.style.position = 'absolute';
            if (this.config.center === false) {
                this.loader.style.bottom = 'auto';
            }
        }

        if (this.config.overlay) {
            this.overlay           = document.createElement('div');
            this.overlay.className = 'overlay-loader';
            if (this.config.container !== document.body) {
                this.overlay.style.position = 'absolute'
            }
            if (this.config.backgroundOverlay) {
                this.overlay.style.background = this.config.backgroundOverlay
            }
            this.overlay.appendChild(this.loader);
            this.config.container.insertBefore(this.overlay, this.config.container.firstChild);
        } else {
            this.config.container.insertBefore(this.loader, this.config.container.firstChild);
        }
    }

    /**
     * Hide loader
     */
    hide() {
        if (this.config.overlay) {
            this.overlay.parentNode && this.overlay.parentNode.removeChild(this.overlay);
        } else {
            this.loader.parentNode && this.loader.parentNode.removeChild(this.loader);
        }

    }
}